import { render, staticRenderFns } from "./SchedulesAndBellsWidget.vue?vue&type=template&id=697e65b2&"
import script from "./SchedulesAndBellsWidget.vue?vue&type=script&lang=js&"
export * from "./SchedulesAndBellsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports